module.exports = __webpack_public_path__ + "img/ribbon.ce11699b.svg";